import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { getProfile } from '../../components/Service/UserService';
import { TextField, Box, Typography } from '@mui/material';
import { useProfile } from '../../Context/ProfileContext';
import Spinner from 'react-bootstrap/Spinner';
import Loading from "../../css/Loading.js"
const Dashboard = () => {
    const { profile, loading } = useProfile(); // Lấy dữ liệu từ context
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);

    // Hiển thị spinner khi đang tải dữ liệu
    if (loading) {
        return (
            <Loading></Loading>
        );
    }

    const cardStyle = {
        height: '400px',
        display: 'flex',
        alignItems: 'center',
        padding: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        backgroundColor: 'white',
    };

    const avatarStyle = {
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '3px solid #007bff',
        marginTop: "-200px"
    };

    const titleStyle = {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#007bff',
        marginBottom: '15px',
    };

    const buttonStyle = {
        padding: '8px 20px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    };


    return (
        <div className="container-fluid py-4">
            <div className="header-container">
                <div className="header-line"></div>
                <div className="header-title">{t("Dashboard")}</div>
                <div className="header-line"></div>
            </div>
            <div className="row mb-4">
                <div className="col-md-6 mb-4">
                    <div style={cardStyle}>
                        <svg
                            strokeWidth="2"
                            style={avatarStyle}
                            xmlns="http://www.w3.org/2000/svg"
                            shapeRendering="geometricPrecision"
                            textRendering="geometricPrecision"
                            imageRendering="optimizeQuality"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            viewBox="0 0 512 481.769"
                        >
                            <path d="M115.202 88.437c64.862-80.147 139.613-123.73 195.75-52.435 64.323 3.378 89.361 101.747 45.161 150.305 7.745 1.469 13.845 6.6 16.332 14.277 1.567 4.877 1.694 10.898-.245 18.066l-7.813 22.228c-1.606 4.563-3.173 7.843-6.845 10.751-2.957 2.35-6.228 3.574-10.517 3.849-2.163 22.266-14.041 33.557-29.218 47.833 17.635 32.617 54.629 38.815 86.051 44.886C451.946 357.49 512 402.895 512 454.371v20.974c0 3.535-2.889 6.424-6.434 6.424H6.434c-3.545 0-6.434-2.889-6.434-6.424v-18.977c0-61.845 62.972-98.369 113.508-105.135 35.271-4.72 64.862-9.499 78.629-49.146-14.002-12.142-25.547-23.403-28.974-47.099a23.495 23.495 0 01-7.863-2.791l-.911-.577c-5.277-3.34-8.969-8.52-11.466-14.277-2.899-6.6-4.181-14.316-4.475-20.122v-9.528c.225-8.509 1.077-15.285 7.324-21.953l-1.155-.598c-2.526-31.569 4.866-86.335-29.415-96.705zm35.662 112.47c4.034-11.554 13.415-7.843 26.791-2.957-5.337-24.225.96-43.143 19.926-56.255 40.461-27.995 58.742-4.034 102.59-39.343 25.195 12.68 47.736 34.134 36.25 101.14 12.152-9.214 29.679-8.352 24.167 12.054l-7.53 21.337c-1.802 5.101-3.007 6.952-9.459 6.609-2.85-.147-5.719-1.253-8.578-3.143 2.644 31.481-12.642 41.753-31.765 60.22-29.464 28.426-63.922 27.251-94.502.049-17.909-15.931-33.822-25.605-34.614-58.36-4.642 1.43-9.029 1.685-12.867-.499-7.638-4.347-10.429-16.999-10.84-25.107-.166-3.26-.029-12.426.431-15.745zM307.3 313.133c7.011 11.485 17.136 19.192 28.436 23.872-45.239 33.195-107.702 30.179-154.233 1.812 11.584-6.238 18.419-14.786 22.942-26.076 16.637 13.66 34.527 20.709 52.495 20.7 17.469-.01 34.624-6.649 50.36-20.308z" />
                        </svg>
                        <div style={{ marginLeft: '20px' }}>
                            <h5 style={titleStyle}>{t("CUSTOMER INFORMATION")}</h5>
                            <div div style={{ height: "350px" }}>
                                <p><strong>{profile?.name || "N/A"}</strong></p>
                                <p>{t("Member")}: <span style={{ color: 'blue' }}>{profile?.membership || t("Not yet rated")}</span></p>
                                <p>Email: {profile?.email || "N/A"}</p>
                                <p>{t("Phone number")}: {profile?.phone || "N/A"}</p>
                                <p>{t("Balance")}: {profile?.balance && profile?.balance !== "null"
                                    ? parseFloat(profile.balance).toLocaleString('vi-VN', {

                                    })
                                    : (0).toLocaleString('vi-VN', {

                                    })} </p>
                                <p>{t("Reward points")} {profile?.credit && profile?.credit !== "null"
                                    ? parseFloat(profile.credit).toLocaleString('vi-VN', {

                                    })
                                    : (0).toLocaleString('vi-VN', {

                                    })} </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div style={cardStyle}>
                        <svg

                            style={avatarStyle}

                            width="100%" height="100%" viewBox="0 0 1350 489" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37 85H726V404H37V85Z" fill="#F2721E" />
                            <path d="M726 85H1313V404H726V85Z" fill="#040053" />
                            <path d="M161.5 332V185.5H106V157H248V185.5H192.5V332H161.5Z" fill="white" />
                            <path d="M282.359 332V157H313.109V332H282.359Z" fill="white" />
                            <path d="M359.955 332V157H425.205C480.205 157 518.205 194.75 518.205 244V244.5C518.205 293.75 480.205 332 425.205 332H359.955ZM390.705 304H425.205C461.955 304 485.955 279.25 485.955 245V244.5C485.955 210.25 461.955 185 425.205 185H390.705V304Z" fill="white" />
                            <path d="M528.549 332L605.5 157H634L711.049 332H678.549L660.799 289.75H578.049L560.049 332H528.549ZM589.299 262.5H649.549L619.299 192.5L589.299 262.5Z" fill="white" />
                            <path d="M741.059 332V157H806.309C861.309 157 899.309 194.75 899.309 244V244.5C899.309 293.75 861.309 332 806.309 332H741.059ZM771.809 304H806.309C843.059 304 867.059 279.25 867.059 245V244.5C867.059 210.25 843.059 185 806.309 185H771.809V304Z" fill="white" />
                            <path d="M938.365 332V157H969.115V332H938.365Z" fill="white" />
                            <path d="M1098.96 335C1044.21 335 1008.21 296 1008.21 245V244.5C1008.21 195.5 1045.71 154 1098.46 154C1128.96 154 1147.71 162.5 1165.71 177.75L1146.21 201C1132.71 189.5 1119.46 182.25 1097.21 182.25C1064.96 182.25 1040.46 210.5 1040.46 244V244.5C1040.46 280.5 1064.21 307 1099.96 307C1116.46 307 1131.46 301.75 1142.21 293.75V261H1097.46V234.25H1171.96V307.75C1154.71 322.5 1129.96 335 1098.96 335Z" fill="white" />
                            <path d="M1213.76 332V157H1244.51V332H1213.76Z" fill="white" />

                        </svg>
                        <div style={{ marginLeft: '20px' }}>
                            <h5 style={titleStyle}>{t("PERSON IN CHARGE")}</h5>
                            <div style={{ height: "350px" }}>
                                <p><strong>{t("Team Support")}</strong></p>
                                {/* <p>Chuyên viên CSKH</p> */}
                                <p>{t("Phone number")}: 0918245138</p>
                                Zalo: <a style={{ textDecoration: "none" }} href='https://zalo.me/249430863847441963'>https://zalo.me/249430863847441963</a>
                                <p>Email: support@tidadigi.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div >
    );
};

export default Dashboard;
